//* Importing necessary files and modules
import { useState, useCallback } from "react";

//! Importing API functions
import { importHistoryTeacherAPI } from "../../importHistory/importHistoryTeacherAPI";

//? Importing necessary types
import type { ImportHistoryTeacher } from "../../importHistory/types/typesTeacher";

//? Importing necessary types
interface ImportStatus extends ImportHistoryTeacher {}

export function useImportHistory(token: string) {
  const [importHistory, setImportHistory] = useState<ImportStatus[]>([]);
  const [isFetchingHistory, setIsFetchingHistory] = useState<boolean>(false);
  const fetchImportHistory = useCallback(async () => {
    setIsFetchingHistory(true);
    try {
      const response = await importHistoryTeacherAPI.getAll("", 1, token, 100);
      setImportHistory(response.import_histories);
    } catch (error) {
      console.error("Erro ao buscar históricos de importação:", error);
    } finally {
      setIsFetchingHistory(false);
    }
  }, [token]);
  return {
    importHistory,
    isFetchingHistory,
    fetchImportHistory,
    setImportHistory,
  };
}
